import { ArrowUpRight } from "lucide-react";
import { SITE } from "@/data/site";
import { Reveal } from "./Reveal";

const XIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5 fill-current"><path d="M18.9 2H22l-7.4 8.5L23 22h-6.8l-5.3-6.9L4.8 22H1.7l7.9-9L1 2h7l4.8 6.3L18.9 2Zm-1.2 18h1.9L6.4 3.9H4.4L17.7 20Z" /></svg>
);

const TgIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5 fill-current"><path d="M21.9 4.3 18.7 19.4c-.2 1.1-.9 1.3-1.8.8l-4.9-3.6-2.4 2.3c-.3.3-.5.5-1 .5l.3-5 9.1-8.2c.4-.4-.1-.6-.6-.2L6.2 13 1.4 11.5c-1-.3-1.1-1 .2-1.5L20.5 2.8c.9-.3 1.7.2 1.4 1.5Z" /></svg>
);

export const Footer = () => (
  <footer className="relative overflow-hidden pt-24 sm:pt-36" data-testid="site-footer">
    <div className="absolute bottom-0 left-1/2 h-[400px] w-[800px] -translate-x-1/2 rounded-full bg-teal-500/15 blur-[140px]" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.35em] text-teal-300">Final memo</p>
        <h2 className="mt-6 font-display text-5xl font-black uppercase leading-[0.9] sm:text-8xl">
          Report to <br /><span className="text-gold">the boss.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <div className="mt-12 flex flex-wrap gap-4">
          <a href={SITE.xUrl} target="_blank" rel="noopener noreferrer" data-testid="social-x-link"
            className="btn-gold clip-chip flex items-center gap-3 px-7 py-4 font-mono text-sm font-bold uppercase tracking-[0.2em]">
            <XIcon /> Follow on X <ArrowUpRight className="h-4 w-4" />
          </a>
          <a href={SITE.telegramUrl} target="_blank" rel="noopener noreferrer" data-testid="social-telegram-link"
            className="clip-chip flex items-center gap-3 border border-teal-400/40 px-7 py-4 font-mono text-sm font-bold uppercase tracking-[0.2em] text-teal-200 transition-colors hover:border-amber-400 hover:text-amber-300">
            <TgIcon /> Join Telegram <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </Reveal>
      <div className="mt-24 flex flex-col gap-6 border-t border-teal-400/15 py-10 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          <img src="/img/logo.png" alt="" className="h-9 w-9 rounded-full ring-1 ring-amber-400/50" />
          <span className="font-display font-bold tracking-wider text-gold">CORPORATE OVERLORD</span>
        </div>
        <p className="max-w-md text-xs leading-relaxed text-slate-400">
          {SITE.ticker} is a satire memecoin with no intrinsic value or expectation of financial return. Not financial advice.
          The Overlord accepts no liability, only tribute.
        </p>
      </div>
    </div>
  </footer>
);
